__turbopack_context__.v({
  "className": "hind_madurai_dc1e79ea-module__F8B7SG__className",
});
